<template>
  <a-modal width="60%" :visible="open" @cancel="onClose" @close="onClose" :footer="null">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>

    <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
      <img alt="example" style="width: 100%" :src="previewUrl" />
    </a-modal>
    <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
      <video style="width: 100%" :src="previewUrl" ref="myVideo"
             :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
    </a-modal>

    <div class="contents-grid">
      <a-row :gutter="[16, 24]">
        <a-col :xs="12" :sm="8" :md="6" :lg="5" :xl="4" v-for="(item, index) in imgList" :key="index">
          <div class="content-item">
            <div class="image-wrapper" @click="handleImagePreview(item)">
              <img
                v-if="item"
                :src="item"
                alt="图片"
                class="content-image"
              />
              <div v-else class="no-image">暂无图片</div>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>

    <div class="bottom-control">
      <a-space>
        <a-button type="dashed" @click="cancel">
          {{$t('取消')}}
        </a-button>
      </a-space>
    </div>
  </a-modal>
</template>

<script>
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {getDelivery, logisticsById} from "@/api/order/delivery";


export default {
  name: 'ContentsForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      imgList: [],
      // 1增加,2修改
      formType: 1,
      open: false,
      form: {
        id: null
      },
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    handleImagePreview(imageUrl) {
      if (imageUrl) {
        this.previewUrl = imageUrl;
        this.previewImageVisible = true;
      }
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null
      }
      this.imgDetail = []
      this.record = {
        id: null,
        orderAddressDetail: {},
      }
    },
    /** 修改按钮操作 */
    handleContent(id) {
      this.reset()
      this.formType = 2
      getDelivery({id: id}).then(response => {
        this.imgList=response.data.imgList
      });
      this.form.id= id
      this.open = true
      this.formTitle = '详情'
    },
  }
}
</script>
<style  lang="less" scoped>
.info-table {
  tr {
    height: 50px;
  }
  td {
    display: table-cell;
    vertical-align: top;
    font-size: 16px;
  }
  .first {
    width: 120px;
  }
  .data {
    width: 280px;
  }
}

.contents-grid {
  padding: 20px 0;
  max-height: 600px;
  overflow-y: auto;

  .content-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 10px;
    border: 1px solid #f0f0f0;
    border-radius: 4px;
    transition: all 0.3s;

    &:hover {
      border-color: #1890ff;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    }

    .image-wrapper {
      width: 100%;
      height: 150px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 10px;
      cursor: pointer;
      background-color: #fafafa;
      border-radius: 4px;
      overflow: hidden;

      .content-image {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
      }

      .no-image {
        color: #999;
        font-size: 12px;
      }
    }

    .goods-name {
      font-size: 14px;
      color: #333;
      line-height: 1.5;
      word-break: break-word;
      width: 100%;
    }
  }
}

.bottom-control {
  margin-top: 20px;
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
}
</style>
